/** CustomEvent name: shell「生成报告」与监控页导出逻辑对齐 */
export const STUDIO_MONITORING_EXPORT_EVENT = "xtool-studio-monitoring-export-report";

/** sessionStorage：扫描详情「加入对比集」累计的 scanDisplayId */
export const STUDIO_COMPARE_IDS_KEY = "xtool_studio_compare_ids";
